export enum HighMediumLow {
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
}
